module.exports = [{
      plugin: require('/home/terje/Documents/designlab/guides/node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"#43cbcb","showSpinner":false},
    },{
      plugin: require('/home/terje/Documents/designlab/guides/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[],"offsetY":"80"},
    },{
      plugin: require('/home/terje/Documents/designlab/guides/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":776,"quality":100},
    },{
      plugin: require('/home/terje/Documents/designlab/guides/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/terje/Documents/designlab/guides/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/terje/Documents/designlab/guides/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/terje/Documents/designlab/guides/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
